module.exports = __webpack_public_path__ + "static/media/licenta2.2d14988a.png";